export default __webpack_public_path__ + "static/jersey-03-639d57d18a00802e4ff438ba7bdc1cdf.jpg";